export default () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.29565 18.3333C4.8475 18.3333 4.46386 18.1738 4.14472 17.8546C3.82558 17.5355 3.66602 17.1518 3.66602 16.7037V5.29629C3.66602 4.84814 3.82558 4.4645 4.14472 4.14536C4.46386 3.82622 4.8475 3.66666 5.29565 3.66666H10.9993V5.29629H5.29565V16.7037H16.7031V11H18.3327V16.7037C18.3327 17.1518 18.1731 17.5355 17.854 17.8546C17.5348 18.1738 17.1512 18.3333 16.7031 18.3333H5.29565ZM9.12528 14.0148L7.98453 12.8741L15.5623 5.29629H12.629V3.66666H18.3327V9.37036H16.7031V6.43703L9.12528 14.0148Z"
      fill="#3C52EF"
    />
  </svg>
)
